import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  MISformP1,
  MISformP2,
  MISformP3,
  MISformP4,
  MISformP5,
  MISformP6,
  MISformP7,
  MISformP8,
  MISformP9,
  MISformP10,
  MISformP11,
  MISformP12,
  MISformP13,
  MISformP14,
  MISformP15,
  MISformP16,
  MISformP17,
  MISformP18,
  MISformP19,
  MISformP20,
  MISformP21,
  MISformP22,
  MISformP23,
  MISformP24,
  MISformP25,
  MISformP26,
} from "../../../../core/data/json/MIS_Forms";

import { toast } from "react-toastify";
import { submitMisApplication } from "../../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

interface FormData {
  [key: string]: any;
}

interface TableEntry {
  id: number;
  [key: string]: string | number;
}

interface ValidationErrors {
  [key: string]: string;
}

interface ResponseField {
  fieldName: string;
  responseVal: string;
  responseName: string;
  responseType: string;
  options?: string[];
}

interface FormField {
  fieldNo: string;
  fieldVal: string;
  response: ResponseField[];
}
interface Page1MISProps {
  header:any;
  year:any;
  application:any;
}
const Page1MIS: React.FC<Page1MISProps> = ({ header, year ,application})  => {
  const [formData, setFormData] = useState<FormData>({});
  const [tableData, setTableData] = useState<TableEntry[]>([]);
  const [nextId, setNextId] = useState(1);
  const [validationErrors, setValidationErrors] = useState<ValidationErrors>(
    {}
  );
  const [loading, setLoading]=useState<boolean>(false);
   const navigate = useNavigate();
  const [editingId, setEditingId] = useState<number | null>(null);
const token = useSelector((state: any) => state.auth.token);
  const handleInputChange = (fieldName: string, value: any) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
    // Clear validation error for this field when user starts typing
    if (validationErrors[fieldName]) {
      setValidationErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };
  const getDataField = () => {
    const typeNum = header?.value;
   
    switch (typeNum) {
      case "f8dd542e-637b-48a9-9579-c51d955958f6":
         
        return MISformP1;
      case "ff834af9-ec91-4b64-be9d-8d6431318d60":
       
        return MISformP2;
      case "03272304-d1c1-4de3-80d5-41cc38d92c4e":
        
        return MISformP3;
      case  "4e3264d9-5849-48c2-adb8-8f365ca9b619":
    
      return MISformP4;
      case "d662fb80-e724-4295-84a7-2335043045e6":
  
        return MISformP5;
      case "4abc0a84-c79c-487e-9459-d5bfda288209":
       
        return MISformP6;
      case "3542455a-a9fe-44cb-b582-bc6645cabd13":
       
        return MISformP7;
        case  "60f185c0-0e2f-45e8-8589-0ee7c5b30720":
       
          return MISformP8;
      case "e8e3723e-fc9c-42a8-8e93-8003fdfa384f":
       
        return MISformP9;
      case "19f2c32b-8727-4c56-bb5f-f2ddab040130":
       
        return MISformP10;
      case "c34fc166-a42d-4c35-9ce7-caf23b63cc38":
     
        return MISformP11;
      case "26d4a5d5-5ca2-4188-8469-1add4e7b798f":
    
        return MISformP12;
      case "03f686ae-0289-4567-abe4-611f054fc460":
      
        return MISformP13;
      case "1be7aa2e-c4b4-4eaf-8a39-714ee69751ca":
         return MISformP14;
      case  "49bb7b6e-2c1d-46c5-90ef-d74d63b323f0":
        return MISformP15;
      case "d3732eaf-9f80-4fc3-8431-e53951c21e2a":
        return MISformP16;
      case "d1ac3935-3f20-4740-9538-f6a641a75496":
        return MISformP17;
      case "5985a467-617e-4feb-a33f-f40f947f2c0e":
        return MISformP18;
      case "f0a5a49e-a89f-4536-88d7-4a5ac74a4a1a":
        return MISformP19;
      case "204d4e1b-e3da-4bea-b011-c00de370ee82":
        return MISformP20;
      case "f1abc58d-2016-477e-92bf-ad2a68c83bc8":
        return MISformP21;
      case "ccbd3a6c-80ec-4d9b-a3a0-ee0461f428a7":
        return MISformP22;
      case "e793e2b8-7f7c-489d-91af-70cbd2af1b3a":
        return MISformP23;
      case "2e9b4f1d-2cd3-4f18-89a3-c1cf54edf005":
        return MISformP24;
      case "cc5c3eda-4bb2-422e-a540-18e3c1e4ff57":
        return MISformP25;
      case "35871e1f-26bc-4c6c-82cd-c5b8be6561f7":
        return MISformP26;
      default:
        return [];
    }
  };
  const misForm = getDataField();

  const validateForm = (): boolean => {
    const errors: ValidationErrors = {};
    let isValid = true;

    // Check all required fields from misForm
    misForm.forEach((field) => {
      field.response.forEach((resp) => {
        const value = formData[resp.fieldName];
        if (resp.responseType === "number") {
          // treat empty string, undefined or null as missing
          if (value === undefined || value === null || value === "") {
            errors[resp.fieldName] = `${resp.responseName} is required`;
            isValid = false;
          }
        } else {
          if (!value || (typeof value === "string" && value.trim() === "")) {
            errors[resp.fieldName] = `${resp.responseName} is required`;
            isValid = false;
          }
        }
      });
    });

    setValidationErrors(errors);
    return isValid;
  };

  const renderInputField = (resp: ResponseField) => {
    const commonClasses = `form-control ${
      validationErrors[resp.fieldName] ? "is-invalid" : ""
    }`;

    switch (resp.responseType) {
      case "number":
        return (
          <>
           <input
              type="number"
              step="0.01"
              min="0"
              className={commonClasses}
              placeholder={resp.responseName}
              value={formData[resp.fieldName] ?? ""}
              onChange={(e) => {
                const val = e.target.value;
                // allow clearing input
                if (val === "") {
                  handleInputChange(resp.fieldName, "");
                  return;
                }
                const num = Number(val);
                if (num < 0) return;
                handleInputChange(resp.fieldName, val);  // ✅ Store as string
              }}
            />

            {validationErrors[resp.fieldName] && (
              <div className="invalid-feedback d-block">
                {validationErrors[resp.fieldName]}
              </div>
            )}
          </>
        );

      case "select":
        return (
          <>
            <select
              className={commonClasses}
              value={formData[resp.fieldName] ?? ""}
              onChange={(e) => handleInputChange(resp.fieldName, e.target.value)}
            >
              <option value="">{`Select ${resp.responseName}`}</option>
              {resp.options?.map((option, idx) => (
                <option key={idx} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {validationErrors[resp.fieldName] && (
              <div className="invalid-feedback d-block">
                {validationErrors[resp.fieldName]}
              </div>
            )}
          </>
        );

      case "input":
      default:
        return (
          <>
            <input
              type="text"
              className={commonClasses}
              placeholder={resp.responseName}
              value={formData[resp.fieldName] ?? ""}
              onChange={(e) => handleInputChange(resp.fieldName, e.target.value)}
            />
            {validationErrors[resp.fieldName] && (
              <div className="invalid-feedback d-block">
                {validationErrors[resp.fieldName]}
              </div>
            )}
          </>
        );

        case "date":
     return (
       <>
         <input
           type="date"
           className={commonClasses}
           placeholder={resp.responseName}
           value={formData[resp.fieldName] ?? ""}
           onChange={(e) => handleInputChange(resp.fieldName, e.target.value)}
         />
         {validationErrors[resp.fieldName] && (
           <div className="invalid-feedback d-block">
             {validationErrors[resp.fieldName]}
           </div>
         )}
       </>
     );

    }
  };

  const handleAddMore = () => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields before adding.", {
        position: "top-right",
      });
      return;
    }

    if (editingId !== null) {
      // Update existing entry
      setTableData((prev) =>
        prev.map((entry) =>
          entry.id === editingId ? { ...formData, id: editingId } : entry
        )
      );
      setEditingId(null);
    } else {
      // Add new entry
      const newEntry: TableEntry = {
        ...formData,
        id: nextId,
      };
      setTableData((prev) => [...prev, newEntry]);
      setNextId((prev) => prev + 1);
    }

    // Clear form and errors
    setFormData({});
    setValidationErrors({});
  };

  const handleEdit = (id: number) => {
    const entryToEdit = tableData.find((entry) => entry.id === id);
    if (entryToEdit) {
      const { id: _, ...dataWithoutId } = entryToEdit;
      setFormData(dataWithoutId as FormData);
      setEditingId(id);
      // Scroll to top of form
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setFormData({});
    setValidationErrors({});
  };

  const handleDelete = (id: number) => {
    setTableData((prev) => prev.filter((entry) => entry.id !== id));
    if (editingId === id) {
      setEditingId(null);
      setFormData({});
      setValidationErrors({});
    }
  };

  const handleSubmit = async() => {
  try{  
    if (tableData.length === 0) {
      toast.error("Please add at least one entry before submitting.", {
        position: "top-right",
      });
      return;
    }
    setLoading(true);
    // Exclude 'id' from each entry before submitting
   const entriesToSubmit = tableData.map(({ id, ...rest }) => rest);
    const data={
      headerId: header?.value,
      year: year,
      masterId: application?.id,
      districtGovernorSign:"",
      entries: entriesToSubmit
    };
   const res=  await  submitMisApplication(token,data)
   if(res.success){
    toast.success("Form submitted successfully.", { position: "top-right" });
    setTimeout(()=>{
      navigate('/mis-upload ')
    },1000)
   }else{
    toast.error(res?.message || "Form submission failed.", { position: "top-right" });
   }
  }catch(err){
  
    toast.error("Form submission failed.", { position: "top-right" });
  }finally{
    setLoading(false);
  }
  };

  return (
    <>
       {loading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Submitting...</span>
              </div>
              <div className="fw-bold">Submitting, please wait...</div>
            </div>
          </div>
        )}
    <div className="container mt-4">
      <div className="card">
        <div className="card-header text-white">
          <h3 className="mb-0">
         {header?.label}
          </h3>
        </div>
        <div className="card-body">
          {editingId !== null && (
            <div
              className="alert alert-warning d-flex justify-content-between align-items-center mb-4"
              role="alert"
            >
              <span className="fw-bold">
                Editing Entry #
                {tableData.findIndex((e) => e.id === editingId) + 1}
              </span>
              <button
                className="btn btn-secondary btn-sm"
                onClick={handleCancelEdit}
              >
                Cancel Edit
              </button>
            </div>
          )}

          <div className="mb-3">
            <span className="fw-bold">Entry Form</span>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-primary text-black">
                <tr>
                  <th style={{ width: "8%", minWidth: "60px" }}>S.No.</th>
                  <th style={{ width: "52%", minWidth: "200px" }}>
                    ખાના(Field)
                  </th>
                  <th style={{ width: "40%", minWidth: "250px" }}>
                    જવાબ(Response)
                  </th>
                </tr>
              </thead>
              <tbody>
                {misForm.map((field: FormField, index: number) => (
                  <tr key={index}>
                    <td
                      className="fw-bold text-black"
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      {field.fieldNo}
                    </td>
                    <td
                      className="text-black"
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      {field.fieldVal}
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      {field.response.length === 1 ? (
                        <div>{renderInputField(field.response[0])}</div>
                      ) : (
                        <div className="row g-2">
                          {field.response.map(
                            (resp: ResponseField, respIndex: number) => (
                              <div key={respIndex} className="col-6">
                                {renderInputField(resp)}
                              </div>
                            )
                          )}
                        </div>
                      )}
                       
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button className="btn btn-primary mt-2 mb-4" onClick={handleAddMore}>
            <i className="bi bi-plus-circle me-2"></i>
            {editingId !== null ? "Update Entry" : "Add Details to Table"}
          </button>

          {tableData.length > 0 && (
            <div className="mt-4">
              <h5 className="mb-3">Added Entries</h5>
              <div className="table-responsive">
                <table className="table table-bordered " >
                  <thead className="table-dark">
                    {/* First Header Row */}
                    <tr>
                      <th rowSpan={2} style={{ minWidth: "50px", verticalAlign: "middle", border:"1px solid black" }}>
                        Sr.No.
                      </th>
                      {misForm.map((field: FormField, index: number) => (
                        <th
                          key={index}
                          colSpan={field.response.length > 1 ? field.response.length : undefined}
                          rowSpan={field.response.length === 1 ? 2 : undefined}
                          style={{
                            minWidth: "150px",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            textAlign: "center",
                            verticalAlign: "middle",
                            border:"1px solid black"
                          }}
                        >
                          {field.fieldVal}
                        </th>
                      ))}
                      <th rowSpan={2} style={{ minWidth: "150px", verticalAlign: "middle",border:"1px solid black" }}>
                        Actions
                      </th>
                    </tr>
                    
                    {/* Second Header Row - Only for multi-response fields */}
                    <tr>
                      {misForm.map((field: FormField, fieldIndex: number) => (
                        <React.Fragment key={fieldIndex}>
                          {field.response.length > 1 && field.response.map((resp: ResponseField, respIndex: number) => (
                            <th
                              key={respIndex}
                              style={{
                                minWidth: "120px",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                textAlign: "center",
                                border:"1px solid black"
                              }}
                            >
                              {resp.responseName}
                            </th>
                          ))}
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((entry, index) => (
                      <tr key={entry.id}>
                        <td style={{border:"1px solid black"}}>{index + 1}</td>
                        {misForm.map((field: FormField, fieldIndex: number) => (
                          <React.Fragment key={fieldIndex}>
                            {field.response.map((resp: ResponseField, respIndex: number) => (
                              <td
                                key={respIndex}
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                  padding: "0.75rem",
                                  border:"1px solid black"
                                }}
                              >
                                {entry[resp.fieldName as keyof typeof entry] || "-"}
                              </td>
                            ))}
                          </React.Fragment>
                        ))}
                        <td
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            border:"1px solid black"
                          }}
                        >
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-warning btn-sm"
                              onClick={() => handleEdit(entry.id)}
                            >
                              <i className="bi bi-pencil-square me-1"></i>
                              Edit
                            </button>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDelete(entry.id)}
                            >
                              <i className="bi bi-trash me-1"></i>
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* <div className="mt-4 d-flex flex-column flex-md-row justify-content-between gap-3">
            <div className="mb-3 w-100" style={{ maxWidth: "400px" }}>
              <label className="form-label">
                Name Of The District Governor
              </label>
              <input type="text" className="form-control" />
            </div>
          </div> */}

          <div className="d-flex justify-content-end">
            <div className="d-flex justify-content-end px-5 mb-5">
            <Link
              className="btn btn-info mt-4"
              style={{cursor:"pointer"}}
              data-bs-toggle="modal"
              to="#exampleModalToggle"
              role="button"
            >
              Submit Application
            </Link>
          </div>
          </div>
        </div>
      </div>
       <div className="col-xl-4">
            <div className="card-body">
              {/* Modal */}
              <div
                className="modal fade"
                id="exampleModalToggle"
                aria-hidden="true"
                aria-labelledby="exampleModalToggleLabel"
                tabIndex={-1}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title" id="exampleModalToggleLabel">
                        Forward Application
                      </h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      <p className="mb-1 fs-17">
                        Are you sure you want to forward this application?
                      </p>
                      <p className="mb-3 fs-12 text-danger">
                       Note: Click on Add Another detail to fill up the table 
                      </p>
                     
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-secondary me-3"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        Cancel
                      </button>
                      {/* <button
                        className="btn btn-info"
                        data-bs-target="#exampleModalToggle2"
                        data-bs-toggle="modal"
                        data-bs-dismiss="modal"
                        onClick={handleForward}
                      >
                        Yes Forward
                      </button> */}
                       <button 
                        className="btn btn-info"
                        onClick={handleSubmit}
                        data-bs-dismiss="modal"
                        >
                          Yes Forward
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
       </div>
    </div></>
    
  );
};

export default Page1MIS;



